import { render, staticRenderFns } from "./Editar-colaborador-modal.vue?vue&type=template&id=38231564&scoped=true&"
import script from "./Editar-colaborador-modal.vue?vue&type=script&lang=js&"
export * from "./Editar-colaborador-modal.vue?vue&type=script&lang=js&"
import style0 from "./Editar-colaborador-modal.vue?vue&type=style&index=0&id=38231564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38231564",
  null
  
)

export default component.exports